import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import { CartProvider } from './context/CartContext';
import { LocationProvider } from './context/LocationContext';

// Intercept fetch to automatically sign out deleted or unauthorized users
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  const url = typeof args[0] === 'string' ? args[0] : (args[0] instanceof Request ? args[0].url : '');
  const isAuthEndpoint = url.includes('/api/auth/');

  if (
    (response.status === 401 && !isAuthEndpoint) || 
    (response.status === 403 && !isAuthEndpoint)
  ) {
    if (localStorage.getItem('zoniq_auth') === 'true') {
      localStorage.removeItem('zoniq_auth');
      localStorage.removeItem('zoniq_user');
      localStorage.removeItem('zoniq_token');
      localStorage.removeItem('zoniq_cart');
      localStorage.removeItem('zoniq_cart_event_id');
      localStorage.removeItem('zoniq_session_time');
      window.dispatchEvent(new Event('storage'));
      window.location.href = '/';
    }
  }

  return response;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <LocationProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </LocationProvider>
  </React.StrictMode>
);

// Dismiss the static preloader from index.html once the app has mounted, the
// web fonts are ready, and it has been visible long enough not to flash.
const preloader = document.getElementById('zq-preloader');
if (preloader) {
  const shownAt = performance.now();
  const MIN_VISIBLE_MS = 600;
  const MAX_WAIT_MS = 4000;
  const dismiss = () => {
    const wait = Math.max(0, MIN_VISIBLE_MS - (performance.now() - shownAt));
    window.setTimeout(() => {
      preloader.classList.add('zq-done');
      window.setTimeout(() => preloader.remove(), 500);
    }, wait);
  };
  const fontsReady = document.fonts?.ready ?? Promise.resolve();
  Promise.race([fontsReady, new Promise((r) => window.setTimeout(r, MAX_WAIT_MS))]).then(() =>
    requestAnimationFrame(dismiss)
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
